import { Icon } from "@iconify/react/dist/iconify.js";
import "./style.css";
import { useTranslation } from "react-i18next";

const DynamicFields = ({
    defaultItems,
    listData,
    setListData,
    isValidAddItem = true,
    renderItem,
    className = "",
    addBtnTitle = "add-new-item"
    
}) => {

    const { t } = useTranslation();

    const addItem = () => {
        if (isValidAddItem) {
            setListData([...listData, ...defaultItems]);
        }
    }
    const removeItem = (index) => {
        const updated = listData.filter((_, i) => i !== index);
        setListData(updated);
    }

    const clearAll = () => setListData([defaultItems]);

    return (

        <div className="dynamic-fields-container" >
            <div className={`dynamic-fields-items-container ${className}`}>
                {listData.map((item, index) => (
                    <div key={index} className="dynamic-fields-item">
                        {renderItem(item, index, removeItem)}
                        {listData.length > 1 && <button className="remove-item-btn" onClick={() => removeItem(index)}>
                            <Icon icon="mi:delete" />
                        </button>}
                    </div>
                ))}
            </div>
            {!!isValidAddItem && (
                <button className="add-item-btn" onClick={addItem}>
                    <Icon icon="ph:plus-bold" className="add-item-btn-icon" />
                    {t(addBtnTitle)}
                </button>
            )}
            {listData.length > 1 && (
                <button className="clear-all-btn" onClick={clearAll}>{t("clear-all")}</button>
            )}
        </div>
    )
}

export default DynamicFields;